// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"a3f0318e","630":"92f7427c","942":"f0e960e3"}[chunkId] + ".chunk.js";
};